import React, { useCallback } from "react";
import { Grid } from "semantic-ui-react";
import DeleteIcon from "@commonComponents/deleteIcon";
import InputField from "@commonComponents/formComponents/CustomInputField";
import DropDown from "@commonComponents/formComponents/CustomDropDown";

const EconomicOperatorForm=({dataSource,tableName,onChange,onSelect,onBlur,deleteData,renderAtFirst,renderAtLast,countryList})=>{
  const {id,name,postalCode,eoriNo,city,country,streetName,streetNumber}=dataSource
  const onChangeHandler=useCallback(({target:{value,name}})=>onChange(id,tableName,{[name]:value}),[tableName,id,onChange])
  const onDropDownChange=useCallback((e, {value,name})=>onSelect(id,tableName,{[name]:value,id}),[tableName,id,onSelect])
  const onBlurHandler=useCallback(({target:{value,name}})=>onBlur(tableName,{[name]:value,id}),[tableName,id,onBlur])
  
  return (
     <div  className="formContainer">
    <Grid.Row>
      {renderAtFirst && renderAtFirst({dataSource,onChangeHandler,onBlurHandler})}
      <Grid.Column>
      <InputField
          id={`name${id}`}
          name="name"
          type="text"
          label="NAME"
          value={name}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
        />
      </Grid.Column>
      <Grid.Column>
      <InputField
          id={`address${id}`}
          type="text"
          label="ADDRESS"
          name="streetName"
          value={streetName}
          clearInput={false}
         onChange={onChangeHandler}
          onBlur={onBlurHandler}
        />
      </Grid.Column>
      <Grid.Column>
      <InputField
          id={`houseNo${id}`}
          type="text"
          label="HOUSE_NO"
          name="streetNumber"
          value={streetNumber}
          clearInput={false}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
        />
      </Grid.Column>
      <Grid.Column>
      <InputField
          id={`zipCode${id}`}
          type="text"
          name="postalCode"
          label="ZIP_CODE"
          value={postalCode}
          clearInput={false}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
        />
      </Grid.Column>
      <Grid.Column>
      <InputField
          id={`place${id}`}
          type="text"
          label="PLACE"
          name="city"
           value={city}
          clearInput={false}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
        />
      </Grid.Column>
      <Grid.Column>
      <DropDown
          id={`country${id}`}
          label="COUNTRY"
          clearable
          labelClass="text-none"
          name="country"
          data={countryList}
          value={country}
          text={country}
          onChange={onDropDownChange}
        />
     
      </Grid.Column>
      <Grid.Column>
      <InputField
          id={`eori${id}`}
          type="text"
          label="EORI"
          name="eoriNo"
          value={eoriNo}
          clearInput={false}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
        />
      </Grid.Column>
     {renderAtLast && renderAtLast({onBlur,onChangeHandler,onBlurHandler,onDropDownChange,dataSource,tableName})}
    </Grid.Row>
    <div className="actionbtns">
    <DeleteIcon onClick={()=>deleteData(id,tableName)} />
    </div>
    </div>
  );
}
EconomicOperatorForm.defaultProps = {
    translate:(value)=>value
  }
export default React.memo(EconomicOperatorForm)
